import { useState, useEffect } from "react";

const SearchResult = ({ result, onSelect }) => {
  const [picked, setPicked] = useState(null);
  const [list, setListBool] = useState(false);
  const [userLocation, setUserLocation] = useState(null);


  const handleClick = () => {
    console.log("Child handleClick fired");
    setPicked(result);

    setListBool(false)      // store clicked result locally
    if (typeof onSelect === "function") {
      onSelect(result);
      // send result up to parent
    }
  };

  if (!result) {
    return (

      <div></div>

    );
  }

  return (
    <div className="search-result">

      {/* handleClickList(); */}
      <div style={{ height: "30px" }} className="search-result-item" onClick={() => { handleClick(); }}>
        {result}
      </div>
    </div>
  );
};

export default SearchResult;
